import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, EnvelopeSimple, MapPin, FacebookLogo, InstagramLogo, LinkedinLogo, YoutubeLogo } from '@phosphor-icons/react';

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#641b4d] text-[#F4F4F4] py-16">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <img
            src="/logos/veveru_white.svg"
            alt="Veveru"
            className="h-24 md:h-28 w-auto -ml-4 mb-2"
          />
          <p className="text-sm text-[#E5E2DC] leading-relaxed">
            Modern. Sleek. Durable. Engineered FRP planters for every space.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest mb-4">Quick Links</h4>
          <nav className="flex flex-col gap-2">
            <Link to="/products" data-testid="footer-products-link" className="text-sm text-[#E5E2DC] hover:text-white transition-colors">
              Products
            </Link>
            <Link to="/custom-inquiry" data-testid="footer-custom-link" className="text-sm text-[#E5E2DC] hover:text-white transition-colors">
              Custom Order
            </Link>
            <Link to="/bulk-inquiry" data-testid="footer-bulk-link" className="text-sm text-[#E5E2DC] hover:text-white transition-colors">
              Bulk Inquiry
            </Link>
            <Link to="/track-order" data-testid="footer-track-link" className="text-sm text-[#E5E2DC] hover:text-white transition-colors">
              Track Order
            </Link>
            <Link to="/faq" data-testid="footer-faq-link" className="text-sm text-[#E5E2DC] hover:text-white transition-colors">
              FAQs
            </Link>
          </nav>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest mb-4">Legal</h4>
          <nav className="flex flex-col gap-2">
            <Link to="/legal/privacy-policy" data-testid="footer-privacy-link" className="text-sm text-[#E5E2DC] hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/legal/terms-and-conditions" data-testid="footer-terms-link" className="text-sm text-[#E5E2DC] hover:text-white transition-colors">
              Terms &amp; Conditions
            </Link>
            <Link to="/legal/refund-policy" data-testid="footer-refund-link" className="text-sm text-[#E5E2DC] hover:text-white transition-colors">
              Cancellation &amp; Refund
            </Link>
            <Link to="/legal/shipping-policy" data-testid="footer-shipping-link" className="text-sm text-[#E5E2DC] hover:text-white transition-colors">
              Shipping Policy
            </Link>
            <Link to="/legal/contact-us" data-testid="footer-contact-link" className="text-sm text-[#E5E2DC] hover:text-white transition-colors">
              Contact Us
            </Link>
          </nav>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest mb-4">Contact</h4>
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2 text-sm text-[#E5E2DC]">
              <Phone size={18} weight="light" />
              <span>+91 6374 302 212</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-[#E5E2DC]">
              <EnvelopeSimple size={18} weight="light" />
              <span>purchase@modshell.live</span>
            </div>
            <div className="flex items-start gap-2 text-sm text-[#E5E2DC]">
              <MapPin size={18} weight="light" className="mt-1" />
              <span>SF.No 389/11, Balaji Industrial Park II,<br />Annur, Coimbatore-641107</span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-12 pt-8 border-t border-[#7a5e75]">
        <div className="flex justify-center gap-6 mb-6">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" data-testid="social-facebook" className="text-[#E5E2DC] hover:text-white transition-colors">
            <FacebookLogo size={24} weight="regular" />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="text-[#E5E2DC] hover:text-white transition-colors">
            <InstagramLogo size={24} weight="regular" />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" data-testid="social-linkedin" className="text-[#E5E2DC] hover:text-white transition-colors">
            <LinkedinLogo size={24} weight="regular" />
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" data-testid="social-youtube" className="text-[#E5E2DC] hover:text-white transition-colors">
            <YoutubeLogo size={24} weight="regular" />
          </a>
        </div>
        <p className="text-center text-sm text-[#E5E2DC]">© 2026 Veveru. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;